module.exports = __webpack_public_path__ + "static/logo-3b4c78787c19c6556e5ccde0f4541792.png";